import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function ProgressStep({ isComplete, isUserJourneyCompleted, url, index, text, isSelected }) {
  return (
    <li
      className={classNames('BookingNavigation_item', {
        active: isSelected,
        complete: isComplete,
      })}
    >
      {isComplete && !isUserJourneyCompleted ? (
        <a href={url} className="BookingNavigation_link" rel="nofollow">
          <span className="BookingNavigation_step">{index + 1}</span>
          <span className="BookingNavigation_linkTitle">{text}</span>
        </a>
      ) : (
        <div className="BookingNavigation_link">
          <span className="BookingNavigation_step">{index + 1}</span>
          <span className="BookingNavigation_linkTitle">{text}</span>
        </div>
      )}
    </li>
  );
}

ProgressStep.propTypes = {
  index: PropTypes.number,
  isComplete: PropTypes.bool,
  isSelected: PropTypes.bool,
  isUserJourneyCompleted: PropTypes.bool,
  text: PropTypes.string,
  url: PropTypes.string,
};

ProgressStep.defaultProps = {
  index: 0,
  isComplete: false,
  isSelected: false,
  text: '',
  url: '',
};

export default ProgressStep;
